import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button } from "react-bootstrap";

const ModalCrud = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");
  const MAX_POSSIBLE_GRADE_ID = 10; // 4 DAN
  const MAX_POSSIBLE_GRADE_ID_ADMIN = 14; // 8 DAN

  const [isLoading, setLoading] = useState(false);
  const [isSearchingUser, setSearchingUser] = useState(false);
  const [isSearchingResp, setSearchingResp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [userId, setUserId] = useState();
  const [docNumber, setDocNumber] = useState();
  const [lastname, setLastName] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [birthDate, setBirthDate] = useState();
  const [startDate, setStartDate] = useState();
  const [grade, setGrade] = useState();
  const [dojo, setDojo] = useState();
  const [responsibleDocNumber, setResponsibleDocNumber] = useState();
  const [responsibleName, setResponsibleName] = useState("");
  const [createdByUser, setCreatedByUser] = useState();

  const [grades, setGrades] = useState([]);
  const exam = props.exam;

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));

  const level = usuario && usuario.level ? usuario.level : 0;

  var moment = require("moment");

  const buildGrades = (baseGrades) => {
    let MAX_POSSIBLE_GRADE = MAX_POSSIBLE_GRADE_ID;
    if (level >= 3) {
      MAX_POSSIBLE_GRADE = MAX_POSSIBLE_GRADE_ID_ADMIN;
    }

    const newGrades = baseGrades
      .filter((i) => i.id <= MAX_POSSIBLE_GRADE)
      .filter((i) => i.attributes.rank === props.rank);

    setGrades(newGrades);
    if (newGrades.length > 0) setGrade(newGrades[0].id);
    else setGrade(null);
  };

  useEffect(() => {
    buildGrades(props.grades);
    if (exam) {
      setDocNumber(exam.attributes.docNumber);
      setGrade(exam.attributes.grade_id);
      setDojo(exam.attributes.dojo_id);
      setResponsibleDocNumber(exam.attributes.responsibleDocNumber);
      setCreatedByUser(exam.attributes.createdByUser);

      getUserByDocNumber(exam.attributes.docNumber);
      getResponsibleByDocNumber(exam.attributes.responsibleDocNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return (
      !docNumber ||
      docNumber === "" ||
      !lastname ||
      lastname === "" ||
      !name ||
      name === "" ||
      !birthDate ||
      birthDate === "" ||
      !startDate ||
      startDate === "" ||
      !email ||
      email === "" ||
      !dojo ||
      dojo === "" ||
      !grade ||
      grade === "" ||
      !responsibleDocNumber ||
      responsibleDocNumber === "" ||
      !responsibleName ||
      responsibleName === ""
    );
  }

  const clearUserData = () => {
    setUserId(null);
    setLastName(null);
    setName(null);
    setEmail(null);
    setBirthDate("");
    setStartDate("");
  };

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  async function getUserByDocNumber(value) {
    const docNumber = value.replace(/\D/g, "");
    setDocNumber(docNumber);
    if (docNumber && docNumber.length > 6) {
      setSearchingUser(true);
      setErrorMessage(null);
      let initialGrade = [];
      initialGrade.push(props.grades[0]);
      buildGrades(initialGrade);

      // check dni ya cargado en la misma fecha de examen
      await axios
        .get(
          `${API_URL}/temp-exams/?filters[docNumber][$eq]=${docNumber}&filters[examination][id][$eq]=${props.id}&filters[state][$eq]=DRAFT`,
          headerRequest
        )
        .then((res) => {
          // lo encuentra 1 vez y en ALTA ó lo encuentra mas de una 1 vez y en EDIT
          if (
            (res.data.data.length > 0 && !exam) ||
            (res.data.data.length > 1 && exam)
          ) {
            setDocNumber(null);
            clearUserData();
            setErrorMessage(
              `El alumno ${docNumber} ya tiene reserva para esta fecha.`
            );
            setSearchingUser(false);
            return;
          }
        })
        .catch((error) => {
          console.log("Error find by temp-exams by docNumber:", error);
        });

      clearUserData();
      // es EDIT y deberia tener tempUser asociado
      if (exam && exam.attributes.tempUser?.data?.id) {
        const tempUser = exam.attributes.tempUser;

        setUserId(tempUser.data.id);
        setDocNumber(tempUser.data.attributes.docNumber);
        setLastName(tempUser.data.attributes.lastname);
        setName(tempUser.data.attributes.name);
        setEmail(tempUser.data.attributes.email);
        setBirthDate(tempUser.data.attributes.birthDate);
        setStartDate(tempUser.data.attributes.startDate);
      }

      // Buscar los datos en Users: para usar en POST y limitar graduaciones
      await axios
        .get(
          `${API_URL}/users/?populate=exams.grade&filters[docNumber][$eq]=${docNumber}`,
          headerRequest
        )
        .then((res) => {
          const userData = res.data[0];
          if (userData) {
            // si es ALTA uso estos para completar
            if (!exam || exam == null) {
              setDocNumber(userData.docNumber);
              setLastName(userData.lastname);
              setName(userData.name);
              setEmail(userData.email);
              setBirthDate(userData.birthDate);
              setStartDate(userData.startDate);
            }

            // Limitar graduacion que rinde a solo la siguiente a la mas alta que tiene aprobada.
            const userExams = userData.exams;
            if (userExams && userExams.length > 0) {
              var lastGradeId = Math.max.apply(
                Math,
                userExams.map(function (o) {
                  // si es 1 DAN o mayor solo considerar con datos de Japon
                  if (
                    o.grade.id >= 7 &&
                    (o.idAikikai == null || o.dateAikikai == null)
                  ) {
                    return null;
                  }
                  return o.grade.id;
                })
              );
              const nextGrades = props.grades.filter((i) => i.id > lastGradeId);
              if (nextGrades && nextGrades[0]?.id) {
                let onlyGrade = [];
                onlyGrade.push(nextGrades[0]);
                buildGrades(onlyGrade);
              }
            }
          }
        })
        .catch((error) => {
          console.log("Error find by docNumber:", error);
        })
        .finally(() => {
          setSearchingUser(false);
        });
    } else if (name) {
      clearUserData();
      buildGrades(props.grades);
    }
  }

  async function getResponsibleByDocNumber(value) {
    const docNumber = value.replace(/\D/g, "");
    if (docNumber && docNumber.length > 6) {
      setSearchingResp(true);
      axios
        .get(
          `${API_URL}/users/?populate=exams.grade&filters[docNumber][$eq]=${docNumber}`,
          headerRequest
        )
        .then((res) => {
          const userData = res.data[0];
          if (userData) {
            setResponsibleName(`${userData.lastname}, ${userData.name}`);

            // Limitar a que el responsable sea de mayor graduacion que la que evalua
            const userExams = userData.exams;
            if (userExams && userExams.length > 0) {
              var lastGradeId = Math.max.apply(
                Math,
                userExams.map(function (o) {
                  // si es 1 DAN o mayor solo considerar con datos de Japon
                  if (
                    o.grade.id >= 7 &&
                    (o.idAikikai == null || o.dateAikikai == null)
                  ) {
                    return null;
                  }
                  return o.grade.id;
                })
              );
              if (lastGradeId == null || lastGradeId <= grade) {
                setResponsibleName("");
                setErrorMessage(
                  `La Graduación del Responsable ${docNumber} debe ser mayor a la que se obtiene`
                );
                docNumber = "";
              } else {
                setResponsibleName(`${userData.lastname}, ${userData.name}`);
              }
            }
          } else {
            setResponsibleName("");
          }
        })
        .catch((error) => {
          console.log("Error find by docNumber:", error);
        })
        .finally(() => {
          setSearchingResp(false);
        });
    } else if (name) {
      setResponsibleName("");
    }
    setResponsibleDocNumber(docNumber);
    if (docNumber === undefined || docNumber === "") setResponsibleName("");
  }

  const changeDojo = (dojoId) => {
    setDojo(dojoId);
    const dojo = props.dojos.find(({ id }) => id == dojoId);
    const respDoc = dojo.attributes?.responsible?.data?.attributes;
    if (respDoc && respDoc?.docNumber !== "") {
      setResponsibleDocNumber(respDoc.docNumber);
      setResponsibleName(`${respDoc.lastname}, ${respDoc.name}`);
    } else {
      setResponsibleDocNumber(usuario.docNumber);
      setResponsibleName(`${usuario.lastname}, ${usuario.name}`);
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (moment(startDate, true).diff(moment(props.date, true), "days") > 0) {
      setLoading(false);
      setErrorMessage("Fecha del Examen debe ser posterior al Inicio.");
      return;
    }

    let reqUser = {
      data: {
        docNumber,
        lastname: lastname.toUpperCase(),
        name: name.toUpperCase(),
        email: email.toLowerCase(),
        birthDate: birthDate,
        startDate: startDate,
        state: "NEW",
        createdByUser: createdByUser ? createdByUser : usuario.id,
      },
    };
    let reqExam = {
      data: {
        docNumber,
        date: props.date,
        examination: props.id,
        grade_id: grade,
        dojo_id: dojo,
        responsibleDocNumber,
        state: "DRAFT",
        tempUser: userId,
        createdByUser: createdByUser ? createdByUser : usuario.id,
      },
    };

    // Si es EDIT hacer PUT, sino POST
    if (exam) {
      await axios
        .put(`${API_URL}/temp-users/${userId}`, reqUser, headerRequest)
        .then((u) => {
          axios
            .put(`${API_URL}/temp-exams/${exam.id}`, reqExam, headerRequest)
            .then(() => {
              setLoading(false);
              props.onHide(true);
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error with put temp-exams:", error.response);
              setErrorMessage("Hubo un error, intente nuevamente.");
            });
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with put temp-users:", error.response);
          setErrorMessage("Hubo un error, intente nuevamente.");
        });
    } else {
      await axios
        .post(`${API_URL}/temp-users`, reqUser, headerRequest)
        .then((u) => {
          reqExam.data.tempUser = u.data.data.id;
          axios
            .post(`${API_URL}/temp-exams`, reqExam, headerRequest)
            .then(() => {
              setLoading(false);
              props.onHide(true);
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error with post temp-exams:", error.response);
              setErrorMessage("Hubo un error, intente nuevamente.");
            });
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with post temp-users:", error.response);
          setErrorMessage("Hubo un error, intente nuevamente.");
        });
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {exam ? "Editar" : "Crear"} Reserva de Exámen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-1">
            <h5>Datos del Alumno</h5>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="formDocNumber"
              className="has-feedback"
            >
              <Form.Label>Núm. Documento</Form.Label>
              <Form.Control
                type="text"
                placeholder="Núm. Documento"
                value={docNumber}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="10"
                disabled={exam ? true : false}
                onChange={(e) => getUserByDocNumber(e.target.value)}
                //onEnter={(e) => getUserByDocNumber(e.target.value)}
              />
              {isSearchingUser ? (
                <span className="loading form-control-feedback"></span>
              ) : null}
            </Form.Group>
            <Form.Group as={Col} controlId="formLastname">
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                type="text"
                placeholder="Apellido"
                defaultValue={lastname}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formName">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nombres"
                defaultValue={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                defaultValue={email}
                inputMode="email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha Nacim.</Form.Label>
              <Form.Control
                type="date"
                name="birthDate"
                min="1930-01-01"
                max="2050-12-31"
                defaultValue={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formStartDate">
              <Form.Label>Fecha Ingreso</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                min="1950-01-01"
                max="2050-12-31"
                defaultValue={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
          </Row>
          <hr />
          <Row className="mb-1">
            <h5>Datos del Exámen</h5>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Rinde</Form.Label>
              {grades.length > 0 ? (
                <Form.Select
                  value={grade}
                  onChange={(e) => setGrade(e.target.value)}
                >
                  {grades.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.attributes.name}
                      </option>
                    );
                  })}
                </Form.Select>
              ) : (
                <Form.Control
                  readOnly
                  isInvalid
                  disabled
                  value="Sin opciones"
                />
              )}
            </Form.Group>

            <Form.Group as={Col} controlId="formDojo">
              <Form.Label>Dojo</Form.Label>
              <Form.Select
                value={dojo}
                onChange={(e) => changeDojo(e.target.value)}
              >
                <option>seleccione dojo</option>
                {props.dojos
                  .filter((d) => d.attributes.endDate == null)
                  .map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.attributes.name}
                      </option>
                    );
                  })}
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Label>Núm. Doc. Responsable</Form.Label>
            <Form.Group
              as={Col}
              controlId="formResponsibleDocNumber"
              className="has-feedback"
            >
              <Form.Control
                type="text"
                placeholder="DNI responsable"
                value={responsibleDocNumber}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="10"
                onChange={(e) => getResponsibleByDocNumber(e.target.value)}
              />
              {isSearchingResp ? (
                <span className="loading form-control-feedback"></span>
              ) : null}
            </Form.Group>
            <Form.Group as={Col} controlId="formResponsibleLastName">
              <Form.Control readOnly disabled value={responsibleName} />
            </Form.Group>
          </Row>
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ModalCrud;
